import styled from 'styled-components';

export const StyledLogo = styled.img`
  height: 6.5rem;
  padding-top: 1.5rem;
  cursor: pointer;

  @media screen and (max-width: 726px) {
    display: none;
  }
`;
